import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ManagementApiService } from '../../../../../services';
import { CalculationType } from '../../../enums/calculation-type.enum';
import { TighteningMethod } from '../../../enums/tightening-method.enum';
import { MatrixRowModel } from '../../../models/templatesModels/matrix-row-model';
import { UserMatrixModel } from '../../../models/user-matrix-model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { APIRes } from '../../../../idms/models/commonAPI.model';
import { UserMatrixRowModel } from '../../../models/user-matrix-row-model';
@Component({
    selector: 'app-matrix-list',
    templateUrl: './matrix-list.component.html',
    styleUrls: ['./matrix-list.component.scss'],
    standalone: false
})
export class MatrixListComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() newlyAddedMatrix: UserMatrixModel;
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    tooltip_position = 'above';
    userMatrixId: string;
    matrixList: UserMatrixModel[];
    matrixRowsDataSource: MatTableDataSource<MatrixRowModel>;
    matrixRowData: MatrixRowModel[] = [];
    // displayData: MatrixRowModel[] = [];
    displayedColumns: string[] = [
        'select',
        'jointId',
        'calculationType',
        'calculationDate',
        'pressureClassName',
        'pipeSize',
        'gasketName',
        'residualBoltLoad',
        'residualBoltStress',
        'tighteningMethod',
        'toolName',
        'toolPressure',
        'action',
    ];
    selection = new SelectionModel<MatrixRowModel>(true, []);
    expanded: boolean = false;
    editIcon: boolean = false;

    constructor(
        private mgmtApi: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private user_utlity: UserUtilityService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    async ngOnInit() {
        this.ngxUiLoaderService.start();
        let matrixmodels = await this.mgmtApi.getMatrices(false).toPromise();

        this.ngxUiLoaderService.stop();
        if (matrixmodels.success === true) {
            this.matrixList = matrixmodels.response;
        } else {
            this.user_utlity.errorModelPopup(matrixmodels.message);
        }

        this.matrixRowsDataSource = new MatTableDataSource<MatrixRowModel>();
        this.matrixRowsDataSource.sort = this.sort;
    }

    ngOnChanges(changes: SimpleChanges) {
        this?.addNewlyCreatedMatrixToList(changes?.newlyAddedMatrix?.currentValue);
    }

    ngAfterViewInit() {
        this.ngOnInit();
    }

    applyFilter(filterData: string) {
        const filterValue = filterData;
        this.matrixRowsDataSource.filter = filterValue?.trim()?.toLowerCase();
    }

    async showPanel(userMatrixId: string) {
        this.expanded = !this.expanded;
        this.selection.clear();
        this.userMatrixId = userMatrixId;
        this.matrixRowsDataSource = new MatTableDataSource<MatrixRowModel>();
        await this.showData(userMatrixId);
    }

    hidePanel() {
        this.expanded = !this.expanded;
        this.selection = new SelectionModel<MatrixRowModel>(true, []);
        this.selection.clear();
    }

    openfolder(e: boolean) {
        if (this.expanded == true) {
            this.editIcon = true;
        } else {
            this.editIcon = false;
        }
    }

    openModify(event: Event) {
        /*if (this.editIcon == true && this.expanded == true) {*/
        event.preventDefault();
        event.stopPropagation();
        /*}*/
    }

    deleteHandler(event: Event) {
        event.preventDefault();
        event.stopPropagation();
    }
    //TODO - Selection Option is to be Implemented.

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.matrixRowsDataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this.matrixRowsDataSource.data);
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: MatrixRowModel): string {
        if (!row) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.jointId + 1}`;
    }

    userActionHandler(isRefresh: boolean) {
        this.matrixList = [];
        this.ngOnInit();
    }

    // add newly create matrix
    addNewlyCreatedMatrixToList(data: UserMatrixModel) {
        this.matrixList?.push(data);
    }

    async showData(event: string) {
        // this.ngxUiLoaderService.start();
        this.globalEmittersService.refreshLoader.next(true);
        this.matrixRowData = [];
        const res: APIRes<UserMatrixRowModel[]> = await this.mgmtApi.getUserMatrixRows(event).toPromise();

        if (res.success === true) {
            const matrixRowdata: MatrixRowModel[] = [];
            if (res.response.length <= 0) {
                this.globalEmittersService.refreshLoader.next(false);
                return (this.matrixRowData = []);
            } else {
                for (let row of res.response) {
                    const matrixRow: MatrixRowModel = new MatrixRowModel();
                    const calculationResult = JSON.parse(row.calculation);
                    matrixRow.userMatrixRowId = row.userMatrixRowId;
                    matrixRow.userMatrixId = row.userMatrixId;
                    matrixRow.jointId = row.jointID;
                    matrixRow.calculationType = CalculationType[calculationResult.type];
                    matrixRow.calculationDate = calculationResult.time;
                    matrixRow.pressureClassName = calculationResult.output.additional?.pressureClassName;
                    matrixRow.pipeSize = calculationResult.output.additional?.pipeName;
                    matrixRow.gasketName = calculationResult.output.additional?.gasketName;
                    matrixRow.residualBoltLoad = calculationResult.output.bolt?.residualBoltLoad?.metric.stringValue;
                    matrixRow.residualBoltStress = calculationResult.output.bolt?.residualBoltStress?.metric.stringValue;
                    matrixRow.tighteningMethod = TighteningMethod[calculationResult.input.others.tighteningMethod];
                    matrixRow.toolName = calculationResult.output.tools?.find((x) => x.isSelected)?.name;
                    if (calculationResult.output.tools?.find((x) => x.isSelected)?.maximumPressure) {
                        matrixRow.toolPressure =
                            calculationResult.output.tools?.find((x) => x.isSelected)?.maximumPressure.metric.stringValue +
                            ' ' +
                            calculationResult.output.tools?.find((x) => x.isSelected)?.maximumPressure.imperial.stringValue;
                    }
                    matrixRow.userMatrixRow = row;
                    matrixRowdata.push(matrixRow);

                    // this.matrixRowData.every((x) => {
                    //     if (matrixRow.userMatrixRowId !== x.userMatrixRowId) {
                    //         this.displayData.push(matrixRow);
                    //     }
                    // });
                }
                matrixRowdata.sort((x, y) => +new Date(y.calculationDate) - +new Date(x.calculationDate));
                this.matrixRowData = matrixRowdata;
            }
            this.globalEmittersService.refreshLoader.next(false);
            // this.ngxUiLoaderService.stop();
        } else {
            // this.ngxUiLoaderService.stop();
            this.globalEmittersService.refreshLoader.next(false);
            this.user_utlity.errorModelPopup(res.message);
        }
    }
}
